import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setTrue } from "../../store/slices/IdSlice";
import "./yesandnomodel.css";
import {
  setNewPackageModelFalse,
  setSmodelTrue,
} from "../../store/slices/modalSlice";
import SomeThingWentWrong from "../somethingwentwrong/SomeThingWentWrong";
import axios from "axios";
import ApplicantDetails from "./ApplicantDetails";
import ApplicationProcess from "./ApplicationProcess";
import CapsuleList from "./packageFlowModelComponents/CapsuleList";
import { DataObject, serviceInclud } from "../../types/packageFlowModel";
import { useCart } from "../../hooks/useCart";
import VisaApplicationUI from "./packageFlowModelComponents/VisaApplicationUi";
import DropDown from "./packageFlowModelComponents/DropDown";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
const baseUrl = import.meta.env.VITE_API_URL;

interface ApplicantFormData {
  uuid: string;
  name: string;
  passport: string;
  country: string;
}

interface PackageFlowModelProps {
  onAddToCartSuccess?: () => void;
}

const PackageFlowModel: React.FC<PackageFlowModelProps> = ({
  onAddToCartSuccess,
}) => {
  const dispatch = useDispatch();
  const { getData } = useCart();
  const [isError, setIsError] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>();
  const [serviceName, setServiceName] = useState<string>();
  const [servicePrice, setServicePrice] = useState<number>();
  const [selectedID, setSelectedID] = useState<string | null>("");
  const [serviceId, serServiceId] = useState<number | null>();
  const [nameError, setNameError] = React.useState(false);
  const [passportNumberError, setPassportNumberError] = React.useState(false);
  const [countryError, setCountryError] = React.useState(false);

  const [tempHoldValue, setTempHoldValue] = useState<any>(null);
  const [AddCart, setAddCart] = useState<boolean>(false);

  const [serviceIncludePrice, setServiceIcludePrice] = useState<number>();

  const [dataObject, setDataObject] = useState<DataObject>();
  const [serviceInclude, setServiceInclude] = useState<any>();
  const [selectedApplicant, setSelectedApplicant] = useState<{
    name: string;
    passport: string;
    country: string;
  }>({ name: "", passport: "", country: "" });
  const [applicantFormData, setApplicantFormData] =
    React.useState<ApplicantFormData>({
      uuid: "",
      name: "",
      passport: "",
      country: "AE",
    });

  const [finalConfirmationCheckBox, setFinalConfirmationCheckBox] = useState<
    boolean | undefined
  >(undefined);

  const count = serviceInclude?.reduce((acc: any, item: any) => {
    return item.includes === 1 ? acc + 1 : acc;
  }, 0);

  const getServiceId = sessionStorage.getItem("serviceid");
  const packageMainId = sessionStorage.getItem("packageMainId") ?? null;
  useEffect(() => {
    if (getServiceId && packageMainId !== null) {
      const parsedServiceId = getServiceId ? parseInt(getServiceId) : null;
      serServiceId(parsedServiceId);
      const getRecordId = sessionStorage.getItem("packageId");
      if (getRecordId || packageMainId) {
        const parsedRecordId = getRecordId ? parseInt(getRecordId) : null;
        const parsedPackageMainId = packageMainId
          ? parseInt(packageMainId)
          : null;
        getPackageModelNew(
          parsedRecordId,
          parsedPackageMainId,
          parsedServiceId
        );
      }
    } else {
      const parsedServiceId = getServiceId ? parseInt(getServiceId) : null;
      serServiceId(parsedServiceId);
      fetchServiceData(parsedServiceId);
    }
  }, [getServiceId, packageMainId]);

  const getPackageModelNew = async (
    packageId: number | null,
    packageMainId: number | null,
    serviceId: number | null
  ) => {
    try {
      const response = await axios.get(`${baseUrl}/api/cart/PackageModelNew`, {
        params: {
          PackageId: packageId,
          PackageMainId: packageMainId,
          ServiceId: serviceId,
        },
      });
      if (response.data) {
        setDataObject(response.data.dataObject);
        setSelectedOption("yes");
        setServiceName(response.data.dataObject.ServiceName);
        setServicePrice(response.data.dataObject.ServicePrice);
        setTempHoldValue(
          response?.data?.dataObject?.ApplicantInfo?.options[0]?.value
        );
        setServiceInclude(
          response?.data?.dataObject?.applicationProcess?.serviceIncluded
        );
        setServiceName(
          response?.data?.dataObject?.ServiceName ||
            response?.data?.dataObject?.packageName
        );
      }
    } catch (error) {
      console.error("Error fetching Package Model:", error);
      throw error; // optional: rethrow if you want to handle it outside too
    }
  };
  
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState("");

  // const getFilterOptionSearch = (allOptions : any, searchTerm : string) => {
  //   return allOptions.filter((item: any) =>
  //     item.textContent.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  // }

  const fetchServiceData = async (serviceId: number | null) => {
    if (!serviceId) return;
    setIsError(false);
    try {
      const response = await axios.get(`${baseUrl}/api/cart/servicesModelNew`, {
        params: { ServiceId: serviceId },
      });
      if (response.data) {
        setDataObject(response.data.dataObject);
        setSelectedOption("yes");
        setServiceName(
          response?.data?.dataObject?.ServiceName ||
            response?.data?.dataObject?.packageName
        );
        setServicePrice(response.data.dataObject.ServicePrice);
        setTempHoldValue(
          response?.data?.dataObject?.ApplicantInfo?.options[0]?.value
        );
      }
    } catch (error: any) {
      setIsError(true);
      console.error("API Error:", error.message);
    }
  };

  const addApplicant = async (
    name: string,
    passport: string,
    country: string
  ) => {
    const UUID = localStorage.getItem("uuid");
    try {
      const response = await axios.post(`${baseUrl}/api/cart/addApplicant`, {
        uuid: UUID,
        name: name,
        passport: passport,
        country: country,
      });

      if (response.data) {
        setApplicantFormData({
          uuid: "",
          name: "",
          passport: "",
          country: "AE",
        });
        return response.data;
      }
    } catch (error) {
      console.error("Error adding applicant:", error);
    }
  };

  const addToCart = async (dataObject: any) => {
    const UUID = localStorage.getItem("uuid");
    try {
      const cartData = {
        Quantity: 1,
        UUID: UUID,
        dataObject: dataObject,
      };
      const response = await axios.post(
        `${baseUrl}/api/cart/addCartNew`,
        cartData
      );
      if (response.data) {
        setShowSuccess(true); // Show success animation
        setTimeout(() => {
          setShowSuccess(false); // Hide animation after 3000 milliseconds
          dispatch(setNewPackageModelFalse());
          if (onAddToCartSuccess) {
            onAddToCartSuccess();
          }
        }, 1000);
      }
      getData();
    } catch (error: any) {
      console.error(
        "Error occurred:",
        error.response ? error.response.data : error.message
      );
      setAddCart(false);
    } finally {
      sessionStorage.removeItem("serviceid");
      sessionStorage.removeItem("packageId");
      sessionStorage.removeItem("packageMainId");
    }
  };

  const handleProceedButton = async () => {
    if (dataObject?.applicantDetails.status === "active") {
      if (finalConfirmationCheckBox) {
        addToCart(dataObject);
      } else if (finalConfirmationCheckBox === undefined) {
        setFinalConfirmationCheckBox(false);
      }
    } else {
      if (dataObject) {
        let applicant = {};

        if (dataObject?.applicationProcess?.status === "active") {
          let hasError = false;
          const namereg = /^[A-Za-z\s]{1,30}$/;
          if (
            !applicantFormData.name ||
            !namereg.test(applicantFormData.name.trim())
          ) {
            setNameError(true);
            hasError = true;
          } else {
            setNameError(false);
          }
          if (!applicantFormData.passport) {
            setPassportNumberError(true);
            hasError = true;
          } else {
            setPassportNumberError(false);
          }
          if (!applicantFormData.country) {
            setCountryError(true);
            hasError = true;
          } else {
            setCountryError(false);
          }
          if (hasError) return;

          if (applicantFormData.name !== "") {
            const resultApplicant = await addApplicant(
              applicantFormData.name,
              applicantFormData.passport,
              applicantFormData.country
            );

            applicant = {
              name: resultApplicant.name,
              passport: resultApplicant.passport,
              country: resultApplicant.country,
              applicantid: resultApplicant.applicantid, // or resultApplicant.id depending on API structure
            };
            setSelectedApplicant({
              name: resultApplicant.name,
              passport: resultApplicant.passport,
              country: resultApplicant.country,
            });
          } else {
            if (!selectedApplicant.name) {
              setNameError(true);
              setPassportNumberError(true);
              return;
            } else {
              applicant = selectedApplicant;
            }
          }

          if (
            dataObject &&
            !Array.isArray(dataObject.ApplicantInfo.selectedFilter)
          ) {
            dataObject.ApplicantInfo.selectedFilter = [];
          }

          const cleanData: any = structuredClone(applicant);
          dataObject.applicantDetails.applicantData = cleanData;
          dataObject.applicantDetails.status =
            dataObject.applicationProcess.status;
        } else if (dataObject?.ApplicantInfo?.status === "active") {
          dataObject.applicationProcess.serviceIncluded = serviceInclude;
          dataObject.applicationProcess.status =
            dataObject.ApplicantInfo.status;
        } else if (
          tempHoldValue &&
          !dataObject.ApplicantInfo.selectedFilter.includes(tempHoldValue)
        ) {
          dataObject?.ApplicantInfo?.selectedFilter.push(tempHoldValue);

          if (dataObject && dataObject.ApplicantInfo) {
            dataObject.ApplicantInfo.selectedId = selectedID;
          }
        } else {
          dataObject.Type.status = "active";
          dataObject.Type.selectedValue =
            selectedOption === "yes" ? "yes" : "no";

          const packageId = sessionStorage.getItem("packageId");
          const PackageMainId = sessionStorage.getItem("packageMainId");

          dataObject.ServiceId = serviceId || null;
          if (dataObject) {
            dataObject.packageMainId = PackageMainId || "";
          }
          if (dataObject) {
            dataObject.packageId = packageId ?? "";
          }
        }

        const payload = {
          dataObject: dataObject,
        };

        handlePackageApiCall(payload);
      }
    }
  };

  const customIco = (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.548649"
        y="0.548649"
        width="27.9027"
        height="27.9027"
        rx="13.9514"
        fill="white"
      />
      <rect
        x="0.548649"
        y="0.548649"
        width="27.9027"
        height="27.9027"
        rx="13.9514"
        stroke="#E9E9E9"
        strokeWidth="1.0973"
      />
      <circle cx="14.4999" cy="14.4999" r="10.4999" fill="#F4F4F4" />
      <circle cx="14.3434" cy="14.6579" r="3.88251" fill="white" />
      <path
        d="M14.4363 7.73828C14.947 7.73831 15.4403 7.92434 15.8238 8.26159L15.9249 8.3568L16.3832 8.81511C16.509 8.94007 16.6732 9.01895 16.8494 9.03901L16.938 9.04426H17.5946C18.1312 9.04423 18.6475 9.24949 19.0376 9.61796C19.4277 9.98642 19.662 10.4902 19.6925 11.0259L19.6958 11.1454V11.802C19.6958 11.9793 19.7562 12.152 19.8652 12.2898L19.9243 12.3555L20.382 12.8138C20.7613 13.191 20.9825 13.6987 21.0004 14.2333C21.0183 14.7679 20.8317 15.2893 20.4785 15.691L20.3833 15.7921L19.925 16.2505C19.8 16.3762 19.7211 16.5405 19.701 16.7166L19.6958 16.8053V17.4619C19.6958 17.9985 19.4906 18.5147 19.1221 18.9048C18.7536 19.2949 18.2499 19.5292 17.7141 19.5597L17.5946 19.563H16.938C16.761 19.5631 16.5891 19.6227 16.4502 19.7324L16.3845 19.7915L15.9262 20.2492C15.549 20.6285 15.0413 20.8497 14.5067 20.8676C13.972 20.8855 13.4507 20.6989 13.0489 20.3457L12.9478 20.2505L12.4895 19.7922C12.3637 19.6672 12.1995 19.5883 12.0233 19.5683L11.9347 19.563H11.278C10.7415 19.563 10.2252 19.3578 9.8351 18.9893C9.44502 18.6208 9.21069 18.1171 9.18017 17.5814L9.17689 17.4619V16.8053C9.17683 16.6283 9.11716 16.4564 9.00749 16.3174L8.94839 16.2518L8.49073 15.7935C8.1114 15.4163 7.89021 14.9086 7.87228 14.374C7.85434 13.8393 8.04101 13.318 8.39421 12.9162L8.48942 12.8151L8.94773 12.3568C9.07269 12.231 9.15158 12.0668 9.17164 11.8906L9.17689 11.802V11.1454L9.18017 11.0259C9.20949 10.5107 9.42734 10.0244 9.79219 9.65955C10.157 9.29471 10.6434 9.07686 11.1585 9.04754L11.278 9.04426H11.9347C12.1117 9.0442 12.2835 8.98453 12.4225 8.87486L12.4882 8.81576L12.9465 8.35811C13.1417 8.16172 13.3739 8.00585 13.6295 7.89948C13.8852 7.7931 14.1594 7.73832 14.4363 7.73828ZM16.8638 12.5196C16.7407 12.3966 16.5737 12.3274 16.3996 12.3274C16.2255 12.3274 16.0585 12.3966 15.9354 12.5196L13.7732 14.6812L12.9242 13.8328L12.8624 13.7784C12.7305 13.6763 12.5646 13.6283 12.3985 13.6441C12.2325 13.66 12.0786 13.7384 11.9683 13.8635C11.858 13.9887 11.7994 14.1511 11.8045 14.3178C11.8096 14.4846 11.878 14.6431 11.9957 14.7613L13.3089 16.0745L13.3707 16.129C13.497 16.227 13.6548 16.2755 13.8143 16.2655C13.9739 16.2554 14.1243 16.1875 14.2374 16.0745L16.8638 13.4481L16.9183 13.3864C17.0163 13.26 17.0649 13.1023 17.0548 12.9427C17.0448 12.7831 16.9769 12.6327 16.8638 12.5196Z"
        fill="#D4D4D4"
      />
    </svg>
  );

  const newPackageModel = useSelector(
    (state: { modal: { newPackageModel: boolean } }) =>
      state.modal.newPackageModel
  );

  const handleCloseAddModal = () => {
    sessionStorage.removeItem("serviceid");
    sessionStorage.removeItem("packageId");
    sessionStorage.removeItem("packageMainId");
    dispatch(setTrue());
    dispatch(setNewPackageModelFalse());
  };

  const handleOpenPackageModell = () => {
    dispatch(setNewPackageModelFalse());
    dispatch(setSmodelTrue());
  };

  const handleSubtractDataFunction = async (value: string) => {
    const copiedArray = [...(dataObject?.ApplicantInfo.selectedFilter || [])];
    const foundIndex = copiedArray.findIndex((item) => item === value);

    let updatedArray = copiedArray;
    if (foundIndex !== -1) {
      updatedArray = copiedArray.slice(0, foundIndex);
    }

    if (dataObject) {
      dataObject.ApplicantInfo.status = "current";

      dataObject.ApplicantInfo.selectedFilter = updatedArray;
    }

    const payload = {
      dataObject: dataObject,
    };

    handlePackageApiCall(payload);
  };

  const handleTypeChange = () => {
    if (serviceId) {
      fetchServiceData(serviceId);
    } else {
      const getServiceId = sessionStorage.getItem("serviceid");
      if (getServiceId) {
        const parsedServiceId = getServiceId ? parseInt(getServiceId) : null;
        serServiceId(parsedServiceId);
        fetchServiceData(parsedServiceId);
      }
    }
  };

  const handleApplicationProcessChange = () => {
    if (dataObject) {
      dataObject.applicationProcess.status = "upcoming";
    }

    const payload = {
      dataObject: dataObject,
    };

    handlePackageApiCall(payload);
  };

  const handleApplicantDetailChange = () => {
    if (dataObject) {
      dataObject.applicantDetails.status = "upcoming";
    }

    const payload = {
      dataObject: dataObject,
    };

    handlePackageApiCall(payload);
  };

  const handlePackageApiCall = async (payload: any) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/cart/handlePackageNew`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setServicePrice(response?.data?.dataObject?.ServicePrice || 0);
        setDataObject(response?.data?.dataObject);
        setTempHoldValue(
          response?.data?.dataObject?.ApplicantInfo?.options[0]?.value
        );
        setSelectedID(
          response?.data?.dataObject?.ApplicantInfo?.options[0]?.id
        );

        setServiceInclude(
          response.data.dataObject.applicationProcess.serviceIncluded
        );

        if (response.data.dataObject.applicationProcess.serviceIncluded) {
          setServiceIcludePrice(
            response.data.dataObject.applicationProcess.serviceIncluded
              .filter((item: serviceInclud) => item.includes === 1) // Filter items where includes === 1
              .reduce((total: any, item: any) => total + item.PriceAmount, 0) // Calculate the sum of PriceAmount
          );
        }
      }
    } catch (error) {
      console.error("Error posting package data:", error);
      throw error;
    }
  };

  const handleCheckboxChange = () => {
    setFinalConfirmationCheckBox((prev: any) => !prev); // toggle between true and false
  };

  const [showSuccess, setShowSuccess] = useState(false);

  if (isError) {
    return <SomeThingWentWrong />;
  }

  return (
    <>
      <Modal
        show={newPackageModel}
        onHide={handleCloseAddModal}
        dialogClassName={showSuccess ? "success-modal-centered " : "wide-modal"}
        scrollable={!showSuccess}
        backdrop="static"
        centered
        className={`mb-fix slide-from-bottom ${
          showSuccess ? " success-modal-dialog" : ""
        }`}
      >
        {/* {!showSuccess && <Modal.Header closeButton />} */}

        <Modal.Header closeButton></Modal.Header>
        {/* <Modal.Body className="modal-dialog-scrollable custom-modal-dialog "> */}
        <Modal.Body
          className={`custom-modal-dialog  modal-dialog${
            !showSuccess ? "-scrollable" : ""
          }`}
        >
          {showSuccess ? (
            <div className="success-modal-content">
              <div className="d-flex align-items-center w-100 justify-content-center">
                <img
                  src="https://goodhand.b-cdn.net/Assets/Flow/sucsess-main.svg"
                  alt=""
                  className="img-fluid"
                  style={{ maxWidth: 120, marginBottom: 16 }}
                />
              </div>
              <h4 className="font-22 ff-bold text-center mb-0">
                Added to Cart!
              </h4>
              <div className="d-flex align-items-center w-100 justify-content-center">
                <p className="font-16 text-center ff-regular text-muted w-100 ">
                  Your selected service/package has been successfully added.
                  <br />
                  Ready when you are to check out!
                </p>
              </div>
            </div>
          ) : (
            !AddCart && (
              <>
                <div className="container-fluid p-0 flow-modal-wrap">
                  {dataObject?.Type?.isHide === false && (
                    <div
                      className={`d-block d-md-flex mb-2 gap-3 align-items-start `}
                    >
                      <div
                        className={`step-circle-main d-none d-md-block ${
                          dataObject?.Type?.status === "active"
                            ? "active"
                            : dataObject?.Type?.status === "current"
                            ? "current"
                            : ""
                        }`}
                      >
                        {customIco}
                      </div>

                      <div className="flex-grow-1 border-bottom pb-2">
                        <div className=" d-flex align-items-center justify-content-start gap-3">
                          <div
                            className={`step-circle-main d-block d-md-none ${
                              dataObject?.Type?.status === "active"
                                ? "active"
                                : dataObject?.Type?.status === "current"
                                ? "current"
                                : ""
                            }`}
                          >
                            {customIco}
                          </div>
                          <div>
                            <p className="mb-0 text-black ff-bold font-13">
                              Type
                            </p>
                            {dataObject?.Type?.status !== "active" ? (
                              <>
                                <p className="ff-medium font-12 text-black mb-0">
                                  Select One Of the Option
                                </p>
                              </>
                            ) : (
                              <>
                                <div className="capsule px-2 py-1 rounded-pill d-flex align-items-center bg-light text-main ff-semibold font-12 gap-2 bg-3 justify-content-between mt-2">
                                  <div>
                                    {dataObject?.Type?.selectedValue === "yes"
                                      ? "Package "
                                      : "Individually"}
                                    &nbsp;Selected
                                  </div>
                                  <span
                                    className="bg-white rounded-circle d-flex align-items-center justify-content-center p-1 cursor-pointer"
                                    onClick={handleTypeChange}
                                  >
                                    <svg
                                      width="9"
                                      height="9"
                                      viewBox="0 0 9 9"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.914062 7.75653H2.6772L7.30544 3.1283C7.42121 3.01253 7.51304 2.87509 7.57569 2.72383C7.63835 2.57257 7.6706 2.41045 7.6706 2.24673C7.6706 2.083 7.63835 1.92089 7.57569 1.76963C7.51304 1.61837 7.42121 1.48093 7.30544 1.36516C7.18967 1.24939 7.05223 1.15756 6.90097 1.0949C6.74971 1.03225 6.58759 1 6.42387 1C6.26015 1 6.09803 1.03225 5.94677 1.0949C5.79551 1.15756 5.65807 1.24939 5.5423 1.36516L0.914062 5.9934V7.75653Z"
                                        stroke="#EF5858"
                                        strokeWidth="0.881569"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M5.10156 1.80566L6.8647 3.5688"
                                        stroke="#EF5858"
                                        strokeWidth="0.881569"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {dataObject?.Type?.status !== "active" && (
                          <div className="row g-3 pt-3 border-bottom pb-3">
                            {dataObject?.Type?.options?.map((option) => (
                              <div className="col" key={option?.value}>
                                <div
                                  className={`d-flex align-items-center gap-3 pk-card-nw p-2 rounded-4 ${
                                    selectedOption === option?.value
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    setSelectedOption(option?.value)
                                  }
                                >
                                  <div className="bg-3 border-white border border-3 rounded-circle p-2 d-flex align-items-center justify-content-center">
                                    <img
                                      src={option?.icon}
                                      alt={option?.textHeading}
                                      style={{ height: "20px" }}
                                    />
                                  </div>
                                  <div className="d-flex flex-column justify-content-center">
                                    <p className="p-0 font-12 mb-0 text-main ff-medium">
                                      {option?.textHeading}
                                    </p>
                                    <p className="p-0 font-14 mb-0 text-main ff-bold">
                                      {option?.textContent}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        <>
                          {selectedOption === "no" ? (
                            <div className="d-flex gap-3 align-items-start mr-3">
                              <div className="flex-grow-1">
                                <ApplicationProcess
                                  serviceList={dataObject?.Type?.serviceList}
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              {dataObject?.Type?.details?.length > 0 && (
                                <div className="pt-3 pb-3">
                                  {/* Grid view for md and up */}
                                  <div className="row g-3  d-md-flex">
                                    {dataObject?.Type?.details?.map(
                                      (detail) => (
                                        <div
                                          className="col-12 col-md-6"
                                          key={detail.heading}
                                        >
                                          <div className="card border-0 package-info-card rounded-3">
                                            <div className="card-body p-3">
                                              <h6
                                                className="ff-semibold font-12"
                                                dangerouslySetInnerHTML={{
                                                  __html: detail?.heading || "",
                                                }}
                                              ></h6>
                                              <p
                                                className="text-muted mb-0 small font-12 ff-medium"
                                                dangerouslySetInnerHTML={{
                                                  __html: detail?.content || "",
                                                }}
                                              ></p>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>

                                  {/* Swiper view for mobile */}
                                  {/* <div className="d-md-none">
                                    <Swiper
                                      spaceBetween={16}
                                      slidesPerView={1.3}
                                      pagination={{ clickable: true }}
                                      modules={[Pagination]}
                                    >
                                      {dataObject?.Type?.details?.map(
                                        (detail) => (
                                          <SwiperSlide key={detail.heading}>
                                            <div className="card border-0 package-info-card rounded-3">
                                              <div className="card-body p-3">
                                                <h6
                                                  className="ff-semibold font-12"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      detail?.heading || "",
                                                  }}
                                                ></h6>
                                                <p
                                                  className="text-muted mb-0 small font-12 ff-medium"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      detail?.content || "",
                                                  }}
                                                ></p>
                                              </div>
                                            </div>
                                          </SwiperSlide>
                                        )
                                      )}
                                    </Swiper>
                                  </div> */}
                                </div>
                              )}
                            </>
                          )}
                        </>
                      </div>
                    </div>
                  )}

                  {/* <div className="d-flex mb-3 gap-3 align-items-start border-bottom pb-3">
              <div className="step-circle-main">{customIco}</div>

              <div className="flex-grow-1">
                <p className="mb-0 text-black ff-bold font-13">
                  Manage Services
                </p>
                <p className="ff-medium font-12 text-black mb-0">
                  {serviceInclude?.length} Services Included
                </p>
                <VisaApplicationUI
                  serviceId={serviceId ?? 0}
                  serviceInclude={serviceInclude}
                  setServiceInclude={setServiceInclude}
                />
              </div>
            </div> */}

                  {dataObject?.ApplicantInfo?.isHide === false && (
                    <div className="d-block d-md-flex mb-2 gap-3 align-items-start">
                      <div
                        className={`step-circle-main d-none d-md-block  ${
                          dataObject?.ApplicantInfo?.status === "active"
                            ? "active"
                            : dataObject?.ApplicantInfo?.status === "current"
                            ? "current"
                            : ""
                        }`}
                      >
                        {customIco}
                      </div>

                      <div className="flex-grow-1 border-bottom pb-2">
                        <div className="d-flex align-items-center   gap-3">
                          <div
                            className={`step-circle-main d-block d-md-none  ${
                              dataObject?.ApplicantInfo?.status === "active"
                                ? "active"
                                : dataObject?.ApplicantInfo?.status ===
                                  "current"
                                ? "current"
                                : ""
                            }`}
                          >
                            {customIco}
                          </div>
                          <div>
                            <p className="mb-0 text-black ff-bold font-13">
                              Applicant Overview
                            </p>

                            {dataObject?.ApplicantInfo?.selectedFilter
                              ?.length === 0 && (
                              <>
                                {dataObject?.Type?.status === "active" ? (
                                  <p className="ff-medium font-12 text-black mb-0">
                                    Select One Of The Options
                                  </p>
                                ) : (
                                  <p className="ff-medium font-12 text-black mb-0">
                                    Sponsor & Applicant Information{" "}
                                  </p>
                                )}
                              </>
                            )}

                            <CapsuleList
                              selectedFilter={dataObject?.ApplicantInfo?.selectedFilter?.filter(
                                (item) =>
                                  !dataObject?.ApplicantInfo?.autoOptionSelected?.includes(
                                    item
                                  )
                              )}
                              handleSubtractDataFunction={
                                handleSubtractDataFunction
                              }
                            />
                          </div>
                        </div>
                        {/* {dataObject?.ApplicantInfo?.status !== "active" && (
                    <Stepper
                      steps={dataObject?.ApplicantInfo?.steps}
                      removeOneElementOfArray={removeOneElementOfArray}
                    />
                  )} */}
                        {dataObject?.ApplicantInfo?.status !== "active" && (
                          <>
                            {dataObject?.ApplicantInfo?.options?.length > 0 && (
                              dataObject.isSearchOption ? (
                                <div className="flex-grow-1 border-bottom pb-2">
                                  <div className="pt-3 pb-3">
                                    <input
                                      id="search"
                                      type="text"
                                      className="dedflow-search"
                                      placeholder="Search Activity"
                                      value={searchTerm}
                                      autoComplete="off"
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />

                                    <div className="dedflow-list">
                                      {dataObject.ApplicantInfo.options.filter((item) =>
                                        item.textContent.toLowerCase().includes(searchTerm.toLowerCase())
                                      ).map((option, idx) => (
                                        <button
                                          key={idx}
                                          type="button"
                                          className={`dedflow-item ${
                                            selected === option.textContent ? "active" : ""
                                          }`}
                                          onClick={() => {
                                            setSelected(option.textContent)
                                            setTempHoldValue(option?.value);
                                            setSelectedID(option?.id);
                                            setServicePrice(option?.price);
                                          }}
                                        >
                                          <img
                                            src={option.icon}
                                            alt={option.textContent}
                                            className="dedflow-icon"
                                          />
                                          {option.textContent}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="row g-3 pt-3  pb-3">
                                  {dataObject?.ApplicantInfo?.options?.map(
                                    (option) => (
                                      <div className="col" key={option?.value}>
                                        <div
                                          className={`d-flex align-items-center gap-3 pk-card-nw p-2 rounded-4 ${
                                            tempHoldValue === option?.value
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            setTempHoldValue(option?.value);
                                            setSelectedID(option?.id);
                                            setServicePrice(option?.price);
                                          }}
                                        >
                                          <div className="bg-3 border-white border border-3 rounded-circle p-2 d-flex align-items-center justify-content-center">
                                            <img
                                              src={option?.icon}
                                              alt=""
                                              style={{ height: "20px" }}
                                            />
                                          </div>
                                          <div className="d-flex flex-column justify-content-center">
                                            <p className="p-0 font-14 mb-0 text-main ff-bold">
                                              {option?.textContent}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )
                            )}
                          </>
                        )}{" "}
                        {!dataObject.isSearchOption && dataObject?.ApplicantInfo?.details?.length > 0 && (
                          <div className="row g-3 pt-3 pb-3">
                            {dataObject?.ApplicantInfo?.details?.map(
                              (detail) => (
                                <div
                                  className="col-12 col-md-6"
                                  key={detail.heading}
                                >
                                  <div className="card border-0 package-info-card rounded-3">
                                    <div className="card-body p-3">
                                      <h6
                                        className=" ff-semibold font-12"
                                        dangerouslySetInnerHTML={{
                                          __html: detail?.heading || "",
                                        }}
                                      ></h6>
                                      <p
                                        className="text-muted mb-0 small font-12 ff-medium"
                                        dangerouslySetInnerHTML={{
                                          __html: detail?.content || "",
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {dataObject?.applicationProcess?.isHide === false && (
                    <div className="d-block d-md-flex mb-2 gap-3 align-items-start">
                      <div
                        className={`step-circle-main d-none d-md-block ${
                          dataObject?.applicationProcess?.status === "active"
                            ? "active"
                            : dataObject?.applicationProcess?.status ===
                              "current"
                            ? "current"
                            : ""
                        }`}
                      >
                        {customIco}
                      </div>

                      <div className="flex-grow-1 border-bottom pb-2">
                        <div className="d-flex align-items-center  gap-3">
                          <div
                            className={`step-circle-main d-block d-md-none ${
                              dataObject?.applicationProcess?.status ===
                              "active"
                                ? "active"
                                : dataObject?.applicationProcess?.status ===
                                  "current"
                                ? "current"
                                : ""
                            }`}
                          >
                            {customIco}
                          </div>
                          <div>
                            <p className="mb-0 text-black ff-bold font-13">
                              Manage Services
                            </p>
                            <p className="ff-medium font-12 text-black mb-0">
                              {serviceInclude?.length > 0 ? (
                                <>
                                  {dataObject?.applicationProcess?.status ===
                                    "active" && (
                                    <>
                                      <div className="position-relative d-inline-block capsule-wrapper">
                                        {/* Capsule (Trigger) */}
                                        <div className="capsule px-2 rounded-pill d-flex align-items-center bg-light text-main ff-semibold font-12 gap-2 bg-3 justify-content-between">
                                          <div className="capsule-tooltip">
                                            <span className="font-12 ff-bold">
                                              {count}
                                            </span>
                                            &nbsp; Services Included
                                            <span className="ms-1">
                                              <svg
                                                width="9"
                                                height="5"
                                                viewBox="0 0 9 5"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M1 0.763184L4.5 4.26318L8 0.763184"
                                                  stroke="#385986"
                                                  strokeWidth="1.16667"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>
                                            </span>
                                            {/* Tooltip */}
                                            <DropDown
                                              serviceInclude={serviceInclude}
                                              count={count}
                                            />
                                          </div>
                                          <span
                                            className="bg-white rounded-circle d-flex align-items-center justify-content-center p-1 cursor-pointer"
                                            onClick={
                                              handleApplicationProcessChange
                                            }
                                          >
                                            <svg
                                              width="9"
                                              height="9"
                                              viewBox="0 0 9 9"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M0.914062 7.75653H2.6772L7.30544 3.1283C7.42121 3.01253 7.51304 2.87509 7.57569 2.72383C7.63835 2.57257 7.6706 2.41045 7.6706 2.24673C7.6706 2.083 7.63835 1.92089 7.57569 1.76963C7.51304 1.61837 7.42121 1.48093 7.30544 1.36516C7.18967 1.24939 7.05223 1.15756 6.90097 1.0949C6.74971 1.03225 6.58759 1 6.42387 1C6.26015 1 6.09803 1.03225 5.94677 1.0949C5.79551 1.15756 5.65807 1.24939 5.5423 1.36516L0.914062 5.9934V7.75653Z"
                                                stroke="#EF5858"
                                                strokeWidth="0.881569"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M5.10156 1.80566L6.8647 3.5688"
                                                stroke="#EF5858"
                                                strokeWidth="0.881569"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              ) : (
                                "Services Offered in this Package"
                              )}
                            </p>
                          </div>
                        </div>
                        {dataObject?.ApplicantInfo?.status === "active" &&
                          dataObject?.applicationProcess?.status !==
                            "active" && (
                            <VisaApplicationUI
                              serviceId={serviceId ?? 0}
                              serviceInclude={serviceInclude}
                              setServiceInclude={setServiceInclude}
                              setServiceIcludePrice={setServiceIcludePrice}
                            />
                          )}
                      </div>
                    </div>
                  )}

                  {dataObject?.applicantDetails?.isHide === false && (
                    <div className="d-block d-md-flex mb-2 gap-3 align-items-start">
                      <div
                        className={`step-circle-main d-none d-md-block ${
                          dataObject?.applicantDetails?.status === "active"
                            ? "active"
                            : dataObject?.applicantDetails?.status === "current"
                            ? "current"
                            : ""
                        }`}
                      >
                        {customIco}
                      </div>

                      <div className="flex-grow-1 border-bottom pb-2">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className={`step-circle-main d-block d-md-none ${
                              dataObject?.applicantDetails?.status === "active"
                                ? "active"
                                : dataObject?.applicantDetails?.status ===
                                  "current"
                                ? "current"
                                : ""
                            }`}
                          >
                            {customIco}
                          </div>
                          <div>
                            <p className="mb-0 text-black ff-bold font-13">
                              Applicant Details
                            </p>
                            <p className="ff-medium font-12 text-black mb-0">
                              {dataObject?.applicantDetails?.status ===
                                "active" && selectedApplicant.name ? (
                                <div className="capsule px-2 py-1 rounded-pill d-flex align-items-center bg-light text-main ff-semibold font-12 gap-2 bg-3 justify-content-between mt-2">
                                  <div>
                                    <span
                                      className={`flag-icon flag-icon-${
                                        selectedApplicant.country
                                          ? selectedApplicant.country.toLowerCase()
                                          : "ae"
                                      } me-1`}
                                    ></span>
                                  </div>

                                  <div>
                                    <span className="font-12 ff-bold">
                                      {selectedApplicant.passport}&nbsp;
                                    </span>
                                    - {selectedApplicant.name}
                                  </div>
                                  <span
                                    className="bg-white rounded-circle d-flex align-items-center justify-content-center p-1 cursor-pointer"
                                    onClick={handleApplicantDetailChange}
                                  >
                                    <svg
                                      width="9"
                                      height="9"
                                      viewBox="0 0 9 9"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.914062 7.75653H2.6772L7.30544 3.1283C7.42121 3.01253 7.51304 2.87509 7.57569 2.72383C7.63835 2.57257 7.6706 2.41045 7.6706 2.24673C7.6706 2.083 7.63835 1.92089 7.57569 1.76963C7.51304 1.61837 7.42121 1.48093 7.30544 1.36516C7.18967 1.24939 7.05223 1.15756 6.90097 1.0949C6.74971 1.03225 6.58759 1 6.42387 1C6.26015 1 6.09803 1.03225 5.94677 1.0949C5.79551 1.15756 5.65807 1.24939 5.5423 1.36516L0.914062 5.9934V7.75653Z"
                                        stroke="#EF5858"
                                        strokeWidth="0.881569"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M5.10156 1.80566L6.8647 3.5688"
                                        stroke="#EF5858"
                                        strokeWidth="0.881569"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                </div>
                              ) : (
                                "Name and Passport Number"
                              )}
                            </p>
                          </div>
                        </div>

                        {dataObject?.applicationProcess?.status === "active" &&
                          dataObject?.applicantDetails?.status !== "active" && (
                            <div>
                              <ApplicantDetails
                                applicantFormData={applicantFormData}
                                setApplicantFormData={setApplicantFormData}
                                setSelectedApplicant={setSelectedApplicant}
                                nameError={nameError}
                                setNameError={setNameError}
                                passportNumberError={passportNumberError}
                                setPassportNumberError={setPassportNumberError}
                                countryError={countryError}
                                setCountryError={setCountryError}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  )}

                  {/* {dataObject?.ApplicationConfirmation?.isHide === false && (
              <div className="d-flex mb-3 gap-3 align-items-start  pb-3">
                <div
                  className={`step-circle-main ${
                    dataObject?.ApplicationConfirmation?.status === "active"
                      ? "active"
                      : dataObject?.ApplicationConfirmation?.status ===
                        "current"
                      ? "current"
                      : ""
                  }`}
                >
                  {customIco}
                </div>

                <div className="flex-grow-1">
                  <p className="mb-0 text-black ff-bold font-13">
                    Confirmation
                  </p>
                  <p className="ff-medium font-12 text-black mb-0">
                    Request confirmation
                  </p>

                  <div className="mt-3">
                    <SummaryCard
                      applicationConfirmation={
                        dataObject?.ApplicationConfirmation
                      }
                      setFinalConfirmationCheckBox={
                        setFinalConfirmationCheckBox
                      }
                      finalConfirmationCheckBox={finalConfirmationCheckBox}
                      applicantDetails={dataObject?.applicantDetails?.status}
                    />
                  </div>
                </div>
              </div>
            )} */}
                </div>
              </>
            )
          )}
        </Modal.Body>
        {!showSuccess && (
          <Modal.Footer className="p-0 ">
            {/* <div
            dangerouslySetInnerHTML={{
              __html: dataObject?.ApplicationConfirmation?.finalCheck?.text,
            }}
            className={` ${
              finalConfirmationCheckBox === false ? "text-danger" : "text-black"
            }`}
          ></div> */}
            {dataObject?.applicantDetails?.status === "active" &&
              dataObject?.ApplicationConfirmation?.finalCheck?.text && (
                <div
                  className="d-flex align-items-start gap-2 summary-card__terms px-3 bg-beige m-0 w-100 py-2"
                  onClick={handleCheckboxChange}
                >
                  <input
                    type="checkbox"
                    className="form-check-input summary-card__checkbox"
                    checked={finalConfirmationCheckBox}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        dataObject?.ApplicationConfirmation?.finalCheck?.text ||
                        "",
                    }}
                    className={` ${
                      finalConfirmationCheckBox === false ? "text-danger" : ""
                    }`}
                  ></div>
                </div>
              )}

            <div className="d-flex align-items-center gap-3 justify-content-between w-100 px-3 py-2 m-0">
              <button className="btn btn-primary bg-black w-50 font-14 ff-semibold py-3  bt--cart d-none">
                <a
                  onClick={handleOpenPackageModell}
                  className="text-white text-decoration-none"
                >
                  Package
                </a>
              </button>
              <div>
                <h6 className="mb-0 ff-medium font-14">
                  {dataObject?.Type.selectedValue === "yes"
                    ? dataObject?.packageName || "Package Selected"
                    : serviceName}
                </h6>
                {/* <p className="text-black font-13 text-black ff-bold mb-0">
                {dataObject?.Type?.selectedValue === "yes"
                  ? serviceIncludePrice
                    ? `Price: ${serviceIncludePrice.toFixed(2)}`
                    : ""
                  : servicePrice
                  ? `Price: ${servicePrice.toFixed(2)}`
                  : ""}
              </p> */}
                <p className="text-black font-13 ff-bold mb-0">
                  {(() => {
                    const isYes = dataObject?.Type?.selectedValue === "yes";
                    const price = isYes ? serviceIncludePrice : servicePrice;
                    return price ? (
                      <>
                        Price:{" "}
                        <span className="ff-currency ff-medium font-15"></span>
                        {price.toFixed(2)}
                      </>
                    ) : null;
                  })()}
                </p>
              </div>

              <button
                className="btn btn-primary  font-14 ff-semibold py-3  bt--cart"
                onClick={handleProceedButton}
              >
                PROCEED
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default PackageFlowModel;
